import { motion } from 'framer-motion';
import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "CL__sc-141v21k-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;z-index:9991;height:100vh;width:100vw;"]);
export var Backdrop = motion(styled.div.withConfig({
  componentId: "CL__sc-141v21k-1"
})(["position:fixed;height:100%;width:100%;background:transparent;&[data-visible='true']{background-color:var(--black);}"]));